/**
 * Workspace — the recessed content module mounted into the Instrument Bezel opening.
 *
 * This is the opaque "display" seated into the cavity of the one-glass bezel. It is
 * NOT a floating card and has NO terrain moat around it — it sits flush against the
 * bezel's top + left arms (recessed there) and is inset only from the OPEN bottom
 * and right edges (the bezel has no chrome there, but the module stays contained).
 * Its geometry tracks the same --ib-rail-w the bezel uses, so it grows/shrinks in
 * lockstep with the left spine while the corner and top spine stay fixed.
 *
 * Pages render their content as children; they no longer own any shell chrome
 * (no CollapsiblePanel, no page-layout scaffold, no page header rail). The single
 * scroll owner + the a11y main landmark live here, once.
 */

import type { ReactNode } from 'react';

interface WorkspaceProps {
  children: ReactNode;
  /** Map pages fill the module edge-to-edge (no inner padding); the module clips. */
  variant?: 'default' | 'map';
}

export const Workspace = ({ children }: WorkspaceProps) => {
  return (
    <section className="ib-workspace" aria-label="Content">
      {/* The single app-wide <main> landmark (SkipLink + RouteAnnouncer target it
       * by #main-content). Was a <div>; a real <main> gives AT users the "main"
       * landmark and satisfies WCAG 1.3.1 / one-main-per-page. */}
      <main id="main-content" tabIndex={-1} className="ib-workspace__scroll">
        {children}
      </main>
    </section>
  );
};
